import React from "react";
import "../post.css";
import DayFive from "../images/day_five.jpg";

export default class Post extends React.Component {
  render() {
    return (
      <div className="card">
        <h2 className="header">Day Five</h2>
        <img className="image" alt="itinerary" src={DayFive} />
        <div className="infobar">
          <div className="info">24 Nov 2018</div>
        </div>
        <h3>Morning</h3>
        <p>
          Spend a full day in Kawaguchiko. Catch the Mount Fuji view early in
          the morning before the clouds set in. Mount Fuji Panoramic ropeway is
          a cable car up to the hill adjacent to Mount Fuji for a closer view.
        </p>
        <h3>Afternoon</h3>
        <p>
          Grab a bicycle instead of the round trip bus if it's peak season. You
          can get around Lake Kawaguchiko just fine on two wheels. Kawaguchiko
          Herb Hall is free to enter. Music Forest is open until sun-down.
        </p>
        <h3>Evening</h3>
        <p>
          Look for a place to settle down and rest. Catch the overnight bus to
          Osaka. Willer Express has comfortable seats for a good night's sleep.
          It's equipped with onboard internet and a toilet.
        </p>
      </div>
    );
  }
}
